module.exports = __webpack_public_path__ + "static/netflix-ccxp-7-00aed96e7dc36b05881f1bbad58f722a.jpg";